import React from 'react';
import ScheduleList from '../components/Schedule/List';
import ScheduleTable from '../components/Schedule/Table';

const BusinessHours = (props) => (
  <div className="businesshours__container">
    {props.BusinessHours.Open && (
      <div className="businesshours__list__container">
        <div className="contact-card__item__label">
          {props.Translations.openinghours}
        </div>
        <ScheduleTable {...props.BusinessHours.Open} Translations={props.Translations} />
      </div>
    )}
    {props.BusinessHours.Dropin && (
      <div className="businesshours__list__container">
        <div className="contact-card__item__label">
          {props.Translations.dropinhours}
        </div>
        <ScheduleList
          List={
            props.ShowDropinCompact
              ? props.BusinessHours.DropinCompact.Schedule
              : props.BusinessHours.Dropin.Schedule
          }
        />
      </div>
    )}
  </div>
);

export default BusinessHours;
